module.exports = __webpack_public_path__ + "img/oldfashioned_classical.9f222388.jpg";